// extracted by mini-css-extract-plugin
module.exports = {"root":"Seal_root__A0KlV","image":"Seal_image__Amsx5"};